// Quiz parent component
if (!customElements.get('component-video')) {
  customElements.define('component-video', class Video extends HTMLElement {
    constructor() {
      super();
      this.props = {
        posterDesktop: this.dataset.posterDesktop,
        videoDesktop: this.dataset.videoDesktop,
        posterMobile: this.dataset.posterMobile,
        videoMobile: this.dataset.videoMobile
      }
      this.state = {
        isMobile: window.innerWidth <= 768
      }
    }
    connectedCallback() {
      this.loadVideo();
      window.addEventListener('resize', () => {
        const currentIsMobile = window.innerWidth <= 768;
        if (this.state.isMobile !== currentIsMobile) {
          this.state.isMobile = currentIsMobile;
          this.loadVideo();
        }
      });
    }
    loadVideo() {
      const video = this.querySelector('.js-video');
      if (video) {
        if (this.state.isMobile) {
          if (this.props.posterMobile) video.poster = this.props.posterMobile;
          if (this.props.videoMobile) video.querySelector('.js-source').src = this.props.videoMobile;
        } else {
          if (this.props.posterDesktop) video.poster = this.props.posterDesktop;
          if (this.props.videoDesktop) video.querySelector('.js-source').src = this.props.videoDesktop;
        }
        video.load();
        video.addEventListener('loadeddata', () => {
          video.play();
        });
      }
    }
  });
}
